import React, { useCallback } from 'react'

import { Modal, T, VStack, HStack } from 'govwell-ui'
import { AICommunityAssistantUsageTier } from 'types/graphql'

import AIAssistantUpsellTier from 'src/components/AIAssistant/AIAssistantUpsellTier'
import { useNotification } from 'src/components/shared/Notification/NotificationContext'
import { useNotifyGovWellSalesTeamAboutHigherAIAssistantTier } from 'src/fetch/notify-sales-team'
import { useMyOrgId } from 'src/layouts/AppStateContextLayout/utils'
type Props = {
  isOpen: boolean
  onClose: () => void | Promise<void>
  tiers: AICommunityAssistantUsageTier[]
}

const AIAssistantUpsellModal = ({ isOpen, onClose, tiers }: Props) => {
  const organizationId = useMyOrgId()
  const { notification } = useNotification()
  const { mutateAsync: notifyGovWellSalesTeamAboutHigherAIAssistantTier } =
    useNotifyGovWellSalesTeamAboutHigherAIAssistantTier()

  const handleNotifySalesTeam = useCallback(
    async (tier: AICommunityAssistantUsageTier) => {
      await notifyGovWellSalesTeamAboutHigherAIAssistantTier({ tier: tier.id, organizationId })
      notification.success({
        message: `Thank you for your interest! Our Sales team has been notified and will be in touch soon.`,
      })
      await onClose()
    },
    [notifyGovWellSalesTeamAboutHigherAIAssistantTier, onClose, notification, organizationId]
  )

  return (
    isOpen && (
      <Modal onClose={onClose} width="75%">
        <Modal.Header>Pricing</Modal.Header>
        <Modal.Content>
          <VStack align="start" gap={4} className="w-full">
            <T.BodyLarge className="text-neutral-600">
              Start for free. Upgrade as you go.
            </T.BodyLarge>

            <HStack wrap="wrap" justify="space-between" align="stretch" gap={4}>
              {tiers.map((tier) => (
                <AIAssistantUpsellTier
                  key={tier.id}
                  tier={tier}
                  isDisabled={tier.isDisabled ?? false}
                  handleNotifySalesTeam={handleNotifySalesTeam}
                />
              ))}
            </HStack>
          </VStack>
        </Modal.Content>
      </Modal>
    )
  )
}

export default React.memo(AIAssistantUpsellModal)
